import {Component, input} from '@angular/core';
import {DirectusTranslatedItem} from '@frontend/directus';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {DirectusTooltipComponent} from '../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-certification-label',
  imports: [TranslateDirectusPipe, DirectusTooltipComponent],
  templateUrl: './certification-label.component.html',
})
export class CertificationLabelComponent {
  readonly certification = input.required<DirectusTranslatedItem>();
}
